export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "en": {
        "shippingMethod": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Shipping method"])}
      },
      "de": {
        "shippingMethod": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Versandart"])}
      }
    }
  })
}